import { useState } from "react";
import { Button, Input, Spin } from "antd";
import VoiceGainAuthSvcApi from "../../../apis/VoiceGainAuthSvcApi";
import { AccountStatus } from "../../../content/MainContent/MainContent.types";
import { validate as uuidValidate } from 'uuid';

function SpeechAnalyticsPage() {
  const [accountNumber, setAccountNumber] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [isSuccess, setIsSuccess] = useState<boolean>(false);

  const activateDisabled = accountNumber.length === 0 || isLoading || !uuidValidate(accountNumber);

  async function handleActivateAccount() {
    if (!isLoading) {
      setIsLoading(true);
      const activateAccountResponse = await VoiceGainAuthSvcApi.modAccount(
        accountNumber,
        { status: AccountStatus.Active }
      );
      if (activateAccountResponse.ok) {
        setErrorMsg("");
        setIsLoading(false);
        setIsSuccess(true);
        setAccountNumber("");
      } else {
        setErrorMsg("Failed to activate account. Double check your account ID");
        setIsLoading(false);
      }
    }
  }

  return (
    <div
      style={{
        width: "100%",
        height: "calc(100dvh - 150px)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingTop: "40px",
      }}
    >
      <h1>Speech Analytics</h1>
      <div style={{
        width: '250px',
        height: '2px',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        borderRadius: '2px',
        marginTop: '-12px',
        marginBottom: '15px'
      }} />
      <h3>Activate account</h3>
      <Input
        disabled={isLoading}
        style={{ width: "310px", marginBottom: "15px" }}
        onChange={(e) => {
          setErrorMsg("");
          setIsSuccess(false);
          setAccountNumber(e.target.value);
        }}
        placeholder="Account ID"
        value={accountNumber}
      />
      <Button
        onClick={handleActivateAccount}
        disabled={activateDisabled}
        type="primary"
        style={{
          position: "relative",
          overflow: "hidden",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "15px",
        }}
      >
        Activate account
        {isLoading ? (
          <Spin
            style={{
              zIndex: "300",
              position: "absolute",
            }}
          />
        ) : null}
      </Button>
      {errorMsg === "" ? null : (
        <div
          style={{
            fontSize: "12px",
            color: "red",
          }}
        >
          {errorMsg}
        </div>
      )}
      {isSuccess ? (
        <div
          style={{
            fontSize: "12px",
            color: "green",
          }}
        >
          Account activated successfully
        </div>
      ) : null}
    </div>
  );
}

export default SpeechAnalyticsPage;
